export enum TagTypeEnum {
  CONTACT = "CONTACT",
  PROTOCOL = "PROTOCOL",
  CAMPAIGN = "CAMPAIGN",
  INTEREST = "INTEREST",
}